var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBeyondLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 64,
    viewBox: "0 0 184 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4184_24265)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.4128 51.0191C72.4269 51.8525 72.2351 52.6767 71.854 53.4219C71.492 54.1178 70.9818 54.7294 70.3579 55.2156C69.6981 55.7214 68.9478 56.1024 68.1453 56.3384C67.268 56.6028 66.3546 56.7342 65.4369 56.7286H54.6348V34.5756H66.2938C67.037 34.5655 67.7707 34.7373 68.429 35.0753C69.0527 35.3969 69.605 35.8368 70.0541 36.3693C70.5003 36.9085 70.8468 37.5205 71.0773 38.177C71.3177 38.8327 71.4418 39.5238 71.4441 40.2205C71.4478 41.2906 71.1566 42.3418 70.6015 43.2633C70.0504 44.1986 69.2074 44.9366 68.1969 45.3686C69.4247 45.6979 70.5061 46.4165 71.2721 47.4121C72.0491 48.458 72.4501 49.7262 72.4128 51.0191ZM58.203 37.6156V44.1363H64.772C65.1944 44.1414 65.6131 44.056 65.9986 43.8865C66.3666 43.7228 66.7017 43.4955 66.9874 43.2156C67.2792 42.9268 67.5065 42.5815 67.6552 42.2023C67.8186 41.784 67.8991 41.3391 67.8931 40.8914C67.9275 40.0325 67.632 39.1923 67.0648 38.5363C66.806 38.2393 66.483 38.0027 66.119 37.8435C65.755 37.6841 65.3595 37.6064 64.9611 37.6156H58.203ZM68.7472 50.3763C68.7495 49.9289 68.6689 49.4845 68.5093 49.0654C68.3614 48.6688 68.1464 48.2997 67.873 47.9735C67.6059 47.6602 67.2749 47.4048 66.9014 47.224C66.5159 47.0362 66.0909 46.94 65.6604 46.9433H58.2087V53.7139H65.4397C65.8897 53.7184 66.3351 53.6282 66.7467 53.45C67.1413 53.2793 67.4984 53.0351 67.7985 52.7314C68.1006 52.4187 68.3382 52.0518 68.4978 51.6507C68.6663 51.2414 68.7509 50.8035 68.7472 50.3623V50.3763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.244 57.0394C82.0305 57.0552 80.8268 56.8269 79.7073 56.3686C78.683 55.9469 77.7566 55.326 76.9845 54.544C76.2276 53.7698 75.6326 52.8584 75.2334 51.8605C74.8164 50.8278 74.6054 49.7263 74.6115 48.6156C74.606 47.4995 74.8172 46.3927 75.2334 45.3538C75.6326 44.3467 76.2273 43.4251 76.9845 42.6394C77.7532 41.849 78.6801 41.2219 79.7073 40.798C80.8382 40.3424 82.0526 40.1187 83.2755 40.1412C84.485 40.1249 85.6844 40.3593 86.795 40.8289C87.805 41.2589 88.7196 41.8787 89.4862 42.6535C90.2314 43.4159 90.8115 44.3183 91.1915 45.3061C91.5847 46.3172 91.7851 47.3906 91.7819 48.4724C91.7819 48.7214 91.7713 48.9552 91.7504 49.1742C91.7292 49.3931 91.7083 49.5747 91.6873 49.7187H78.3373C78.3878 50.3997 78.5657 51.0655 78.8618 51.6836C79.1364 52.2501 79.5141 52.7629 79.9767 53.1966C80.8907 54.0505 82.1067 54.5252 83.3701 54.5215C83.837 54.5215 84.3018 54.464 84.7544 54.3503C85.1955 54.2422 85.6188 54.0738 86.0126 53.8507C86.3903 53.6362 86.7343 53.3684 87.0329 53.0563C87.3229 52.7534 87.5591 52.4053 87.7322 52.0261L90.7272 52.8682C90.1133 54.1283 89.1188 55.173 87.8784 55.8605C86.4737 56.6639 84.8699 57.0717 83.244 57.0394ZM88.3083 47.3356C88.2521 46.6754 88.0744 46.0306 87.7838 45.4324C87.5158 44.8752 87.1435 44.3725 86.6861 43.9503C86.231 43.5396 85.701 43.2168 85.1241 42.9987C84.5248 42.7697 83.8871 42.6535 83.244 42.6563C81.9815 42.6493 80.7637 43.1116 79.8363 43.9503C79.3794 44.3702 79.0114 44.8738 78.7529 45.4324C78.4714 46.0331 78.2989 46.677 78.2427 47.3356H88.3083Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7741 60.566C95.0931 60.6278 95.4064 60.6803 95.7142 60.7232C95.9618 60.7597 96.2117 60.7802 96.4622 60.785C96.7122 60.7911 96.9595 60.7319 97.1787 60.6137C97.4267 60.4548 97.6385 60.2474 97.8007 60.0046C98.0641 59.6186 98.2833 59.2054 98.4541 58.7723C98.6777 58.241 98.9373 57.5597 99.2337 56.7288L92.3867 40.4229H95.9865L101.145 53.7141L105.731 40.4229H109.044L101.495 60.5155C101.153 61.453 100.539 62.2718 99.7267 62.8706C98.8878 63.505 97.8101 63.8221 96.4938 63.8221C96.2272 63.8213 95.9612 63.8053 95.697 63.7744C95.3835 63.7351 95.0745 63.6675 94.7741 63.5723V60.566Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.539 57.0403C117.319 57.0593 116.109 56.8258 114.988 56.3553C113.978 55.9292 113.067 55.3075 112.309 54.5274C111.551 53.7473 110.962 52.8252 110.577 51.8164C109.771 49.7367 109.771 47.44 110.577 45.3603C110.965 44.3556 111.555 43.4383 112.314 42.6627C113.085 41.8815 114.005 41.2558 115.023 40.8213C116.645 40.1198 118.447 39.92 120.189 40.2492C121.93 40.5782 123.528 41.4203 124.767 42.6627C125.524 43.4386 126.114 44.3562 126.501 45.3603C127.307 47.44 127.307 49.7367 126.501 51.8164C126.114 52.8216 125.525 53.74 124.767 54.5167C123.996 55.2979 123.076 55.9236 122.059 56.3581C120.948 56.8252 119.748 57.0577 118.539 57.0403ZM113.569 48.6192C113.561 49.3659 113.691 50.1075 113.953 50.8087C114.191 51.4453 114.547 52.0328 115.005 52.5406C115.446 53.0251 115.982 53.4175 116.582 53.6943C117.196 53.9716 117.864 54.1151 118.54 54.1151C119.217 54.1151 119.885 53.9716 120.5 53.6943C121.102 53.4153 121.639 53.0167 122.076 52.5238C122.532 52.009 122.888 51.4175 123.127 50.7778C123.638 49.3695 123.638 47.8324 123.127 46.4241C122.89 45.7782 122.534 45.1806 122.076 44.6613C121.639 44.1684 121.102 43.7701 120.5 43.4908C119.887 43.2084 119.216 43.0644 118.539 43.0697C117.87 43.0675 117.21 43.2174 116.61 43.5076C116.01 43.7959 115.474 44.1984 115.034 44.6922C114.575 45.2134 114.214 45.8102 113.968 46.455C113.7 47.1452 113.565 47.8779 113.569 48.6164V48.6192Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.173 56.7282H141.668V47.5858C141.668 46.0475 141.419 44.9295 140.92 44.2314C140.672 43.8873 140.338 43.6108 139.95 43.428C139.563 43.2453 139.134 43.1625 138.704 43.1872C138.182 43.1897 137.665 43.2849 137.177 43.4679C136.66 43.6596 136.177 43.9285 135.744 44.2651C135.291 44.6148 134.889 45.0238 134.549 45.4805C134.198 45.9504 133.924 46.4714 133.738 47.0244V56.7282H130.232V40.4223H133.419V43.6981C134.067 42.5859 135.03 41.6812 136.191 41.0932C137.426 40.4529 138.806 40.1259 140.203 40.1416C141.054 40.1082 141.9 40.2909 142.657 40.6721C143.278 41.0126 143.797 41.5075 144.161 42.1065C144.548 42.7628 144.812 43.4814 144.941 44.2286C145.093 45.0679 145.168 45.9193 145.165 46.7717L145.173 56.7282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.036 57.039C154.958 57.0488 153.891 56.8195 152.915 56.3681C151.97 55.9294 151.126 55.3088 150.431 54.5436C149.716 53.7517 149.159 52.8358 148.788 51.8432C148.014 49.727 148.003 47.4149 148.757 45.2916C149.109 44.3176 149.638 43.4143 150.319 42.625C150.972 41.8682 151.774 41.2476 152.677 40.8004C153.702 40.3156 154.834 40.0877 155.971 40.1366C157.108 40.1857 158.215 40.5102 159.192 41.0811C160.179 41.6824 161 42.5124 161.582 43.498V33.9541H165.085V52.6741C165.057 52.9694 165.13 53.2653 165.291 53.5162C165.389 53.6111 165.506 53.6849 165.635 53.7335C165.764 53.7817 165.901 53.8034 166.039 53.7969V56.7302C165.678 56.792 165.386 56.8333 165.162 56.8537C164.938 56.8734 164.752 56.8846 164.606 56.8846C163.987 56.9105 163.378 56.7227 162.886 56.3541C162.671 56.1899 162.494 55.9825 162.368 55.7455C162.241 55.5089 162.168 55.2484 162.153 54.9815L162.09 53.7632C161.486 54.7707 160.617 55.6007 159.573 56.166C158.492 56.7527 157.273 57.0536 156.036 57.039ZM156.896 54.1057C157.416 54.104 157.932 54.0195 158.424 53.8559C158.923 53.6953 159.395 53.4648 159.825 53.1709C160.244 52.8852 160.614 52.5377 160.923 52.1408C161.224 51.7599 161.446 51.3251 161.577 50.8608V46.5969C161.387 46.0793 161.113 45.5948 160.765 45.1625C160.424 44.7342 160.021 44.3561 159.57 44.0397C159.136 43.7335 158.658 43.4915 158.152 43.3211C157.665 43.1566 157.153 43.0724 156.638 43.0713C155.965 43.0646 155.301 43.2257 154.71 43.5401C154.125 43.8528 153.61 44.2775 153.196 44.7892C152.763 45.3239 152.424 45.9252 152.193 46.5688C151.95 47.2296 151.825 47.9266 151.826 48.6292C151.822 49.3548 151.957 50.0745 152.225 50.7513C152.481 51.3938 152.857 51.9841 153.334 52.4916C153.789 52.982 154.335 53.3837 154.942 53.6762C155.551 53.9653 156.22 54.1124 156.896 54.1057Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.726 37.0825L16.9181 36.7765L14.7227 33.7421L4.46797 31.6846L0.123047 38.5898L2.28691 41.6354L12.5416 43.693L12.5531 43.6761L12.5731 43.679L16.7174 37.0937L16.726 37.0825Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4836 32.2035L19.5975 36.7733L21.7614 39.8189L32.0162 41.8765L42.2709 43.934L46.6187 37.054L50.9664 30.1516L48.8026 27.1059L42.1705 25.7754L45.0567 21.1916L42.8928 18.1431L36.2608 16.8126L39.1469 12.2288L40.1385 10.6512L43.4918 5.31788L41.3279 2.26946L31.0732 0.211914L26.7397 7.09753L22.3919 14L26.0175 14.727V14.7467L22.3948 14.0196L18.047 20.9221L13.6992 27.8245L15.8545 30.8786L22.4865 32.2091L22.4836 32.2035ZM27.568 30.5979L30.4542 26.014L37.0862 27.3445L34.2001 31.9284L27.568 30.5979Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6387 16.0732L34.8025 19.1217L45.0572 21.1792L42.8934 18.1308L32.6387 16.0732Z",
    fill: "#F7ADA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9177 36.7764H12.5527V43.6788H16.9177V36.7764Z",
    fill: "#D0E8C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.76663 39.3184L2.31641 41.6202L12.5224 43.6693L10.3757 40.6461L3.76376 39.3184H3.76663ZM16.9103 36.7725L12.5539 43.6749H12.574L16.7183 37.0897L16.9103 36.7725Z",
    fill: "#D0E8C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7617 39.833L32.0165 41.8906L21.7617 39.833Z",
    fill: "#FFEAC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2234 37.5146L21.7617 39.8332L32.0165 41.8908L29.8555 38.8452L23.2234 37.5146Z",
    fill: "#FFEAC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1622 12.2002V12.2198L38.6836 12.9834L39.1766 12.203",
    fill: "#FBD1CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.525 11.4893L32.6504 16.0535L26.0212 14.7257L26.0184 14.7314L26.0098 14.7426L32.6389 16.0731L36.2645 16.8001L38.6691 12.9798L39.1506 12.2163L39.162 12.1994L39.1506 12.2163L35.525 11.4893Z",
    fill: "#FBD1CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.494 5.31543L40.1407 10.6488L39.4414 11.7575L43.494 5.32385V5.31543Z",
    fill: "#FFEAC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8715 4.58691L36.9854 9.17077L35.5352 11.4725L39.1607 12.1995L39.4444 11.7476L40.1409 10.6388L43.4942 5.31393L39.8715 4.58691Z",
    fill: "#FFEAC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5369 11.4736L35.5254 11.4905L39.1509 12.2175L39.1624 12.2007L35.5369 11.4736Z",
    fill: "#FDD6AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0652 19.2905L62.9013 16.2421L53.1166 14.28L52.6466 14.1846L48.2988 21.0898L50.414 24.1354L60.6687 26.193L60.6744 26.1846L60.7174 26.193L65.0652 19.2905Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4551 26.0245L37.0871 27.355L30.4551 26.0245ZM45.0576 21.1768L42.1715 25.7606L45.0576 21.1768Z",
    fill: "#FBD1CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4141 24.1357L60.6688 26.1933L60.6745 26.1849L60.6688 26.1933L50.4141 24.1357Z",
    fill: "#D0E8C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8786 21.8096L50.4141 24.1366L60.6688 26.1941L60.6745 26.1857L60.6917 26.1576L58.5536 23.1485L51.8786 21.8096Z",
    fill: "#D0E8C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3143 28.5518L15.8555 30.8732L22.4846 32.2037L23.9463 29.8823L17.3143 28.5518Z",
    fill: "#FFEAC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.46797 31.6846L0.123047 38.5898L3.76579 39.3197L6.66336 34.719L13.2753 36.0439L14.7227 33.7421L4.46797 31.6846Z",
    fill: "#D0E8C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.6632 34.7178L3.76562 39.3185L10.3776 40.6462L13.2752 36.0427L6.6632 34.7178Z",
    fill: "#BBDEB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4838 32.2021L19.5977 36.786L22.4838 32.2021Z",
    fill: "#9CDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5681 30.6084L26.1093 32.9298L22.4838 32.2028L19.5977 36.7866L23.2232 37.5137L26.1093 32.9298L32.7385 34.2603L34.2002 31.9389L27.5681 30.6084Z",
    fill: "#9CDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1088 32.9307L23.2227 37.5145L29.8546 38.8451L32.7378 34.2612L26.1088 32.9307Z",
    fill: "#9CD4C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9459 29.8818L22.4842 32.2032L26.1097 32.9303L27.5686 30.6089L23.9459 29.8818Z",
    fill: "#9CD4C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.293 22.9795L30.4541 26.0251L37.0861 27.3556L38.5478 25.037L28.293 22.9795Z",
    fill: "#F7ADA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2 31.9385L32.7383 34.2599L36.3638 34.9869L42.9959 36.3174L36.3638 34.9869L37.8255 32.6655L34.2 31.9385Z",
    fill: "#F59394"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7388 34.2607L29.8556 38.8446L33.4783 39.5716L36.3644 34.9878L32.7388 34.2607Z",
    fill: "#F58A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3646 34.9873L33.4785 39.5712L40.1105 40.9017L42.9966 36.3178L36.3646 34.9873Z",
    fill: "#F16465"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.825 32.667L36.3633 34.9884L42.9953 36.3189L44.4541 33.9975L37.825 32.667Z",
    fill: "#F47F7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3837 14.0166L19.6954 18.2889L22.3837 14.0166Z",
    fill: "#F59394"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3829 14.0166L19.6946 18.2889L18.0352 20.9219L21.6607 21.6489L24.5468 17.065L31.1789 18.3955L31.1904 18.3759L24.5583 17.0454L26.0085 14.7436L22.3829 14.0166Z",
    fill: "#F59394"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5482 17.0654L21.6621 21.6493L28.2941 22.9798L31.1802 18.396L24.5482 17.0654Z",
    fill: "#F16465"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0088 14.7432L24.5586 17.0449L31.1905 18.3754L32.6379 16.0737L26.0088 14.7432Z",
    fill: "#F47F7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5527 43.6752V43.6949V43.6752ZM14.7252 33.744L16.9091 36.7728L14.7137 33.7412",
    fill: "#A4CC95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5251 43.6696L12.5423 43.6949V43.6752H12.5137L12.5251 43.6696ZM14.7148 33.7496L13.2646 36.0514L16.9102 36.7728L14.7148 33.7412",
    fill: "#A4CC95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2765 36.0439L10.3789 40.6475L12.5256 43.6706L12.5542 43.6762L16.9192 36.7766L13.2765 36.0439Z",
    fill: "#9AC78B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3945 13.999L25.037 14.5267L22.3945 13.999Z",
    fill: "#9CDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7309 7.11426L22.3945 13.9999L25.037 14.5276L26.0201 14.7269L28.9063 10.143L30.3536 7.84128L26.7309 7.11426Z",
    fill: "#9CDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9076 10.1436L26.0215 14.7274L32.6506 16.0551L35.5253 11.4909L28.8933 10.1604L28.9076 10.1436Z",
    fill: "#9BC9C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3536 7.84082L28.9062 10.1426L35.5354 11.4731L36.9856 9.17135L30.3536 7.84082Z",
    fill: "#9CD4C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9069 10.1436L28.8926 10.1604L35.5246 11.4909L35.5361 11.4741L28.9069 10.1436Z",
    fill: "#9BCBB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0755 0.208008L26.7305 7.11327L26.7419 7.09362L30.3648 7.82064L33.2394 3.25643L39.8714 4.58696L41.3302 2.26555L31.0755 0.208008Z",
    fill: "#FFEAC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2399 3.25684L30.3652 7.82105L36.9973 9.15157L36.9858 9.17122L39.8719 4.58736L33.2399 3.25684Z",
    fill: "#FFE1AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7419 7.09473L26.7305 7.11438L30.3533 7.84139L30.3648 7.82174L26.7419 7.09473Z",
    fill: "#D4DBB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.365 7.82129L30.3535 7.84094L36.9855 9.17146L36.997 9.15182L30.365 7.82129Z",
    fill: "#D4D7AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1912 18.376L31.1797 18.3956L34.8024 19.1226L34.7852 19.0974L31.1912 18.376Z",
    fill: "#FBD1CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.264 16.8018L34.8138 19.1035L34.7852 19.0979L34.8024 19.1232L41.4344 20.4537L42.8932 18.1323L36.264 16.8018Z",
    fill: "#F7ADA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1792 18.3955L28.293 22.9794L31.9157 23.7064L34.8018 19.1225L31.1792 18.3955Z",
    fill: "#F6A29C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6388 16.0732L31.1914 18.375L34.7854 19.0964L32.6388 16.0732L36.2643 16.8003L32.6388 16.0732Z",
    fill: "#F9BDB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6387 16.0732L34.7853 19.0964L34.814 19.102L36.2642 16.8003L32.6387 16.0732Z",
    fill: "#F7ADA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8021 19.1221L31.916 23.7059L38.548 25.0365L41.4341 20.4526L34.8021 19.1221Z",
    fill: "#F9BDB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6466 14.1846L48.2988 21.0898L51.8785 21.8084L54.7589 17.233L61.4339 18.5719L61.4396 18.5635L54.8105 17.233L52.6466 14.1846Z",
    fill: "#D0E8C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7593 17.2334L51.8789 21.8088L58.5539 23.1478L61.4343 18.5723L54.7593 17.2334Z",
    fill: "#BBDEB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1165 14.28L62.9012 16.2421L65.0651 19.2905L54.8103 17.233L52.6465 14.1846L53.1165 14.28Z",
    fill: "#ABD69E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0363 20.9209L13.6914 27.8234L17.3141 28.5504L20.2002 23.9665L21.6619 21.6479L18.0363 20.9209Z",
    fill: "#FFEAC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6609 21.6494L20.1992 23.968L26.8312 25.2985L28.2929 22.9799L21.6609 21.6494Z",
    fill: "#FBBB96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2005 23.9678L17.3145 28.5517L23.9465 29.8822L26.8326 25.2983L20.2005 23.9678Z",
    fill: "#FFE1AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.123169 38.5889L2.28703 41.6345L12.5417 43.692L10.3779 40.6464L0.123169 38.5889Z",
    fill: "#ABD69E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5977 36.7861L29.8553 38.8437L32.0163 41.8893L21.7615 39.8317L19.5977 36.7861Z",
    fill: "#4FC2C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8556 38.8447L40.1103 40.9023L42.2742 43.9479L32.0166 41.8903L29.8556 38.8447Z",
    fill: "#EE3F40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1094 40.9023L42.2732 43.9479L46.6182 37.0455L44.4543 33.9971L40.1094 40.9023Z",
    fill: "#EE3F40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4551 33.9972L48.8029 27.0947L50.9667 30.1403L46.6189 37.0456L44.4551 33.9972Z",
    fill: "#F7ADA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4543 33.9971L42.9955 36.3185L40.1094 40.9023L42.2732 43.9479L46.6182 37.0455L44.4543 33.9971Z",
    fill: "#CC3535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8029 27.0947L47.3412 29.4133L44.4551 33.9972L46.6189 37.0456L50.9667 30.1403L48.8029 27.0947Z",
    fill: "#EA877D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3762 23.5596L60.7168 26.1926L62.3762 23.5596Z",
    fill: "#A4CC95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4394 18.5635L61.4337 18.5719L65.0134 19.2905L60.6914 26.1565L60.7172 26.1929L62.3766 23.56L65.065 19.2905L61.4394 18.5635Z",
    fill: "#A4CC95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4331 18.5713L58.5527 23.1467L60.6908 26.1559L65.0128 19.2899L61.4331 18.5713Z",
    fill: "#9AC78B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9011 16.2432L61.4395 18.5646L65.065 19.2916L62.9011 16.2432Z",
    fill: "#93C482"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3313 2.2666L43.4951 5.31503L39.1502 12.2175L36.9863 9.17187L41.3313 2.2666Z",
    fill: "#EAB662"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1503 12.2165L36.2642 16.8004L32.6387 16.0734L36.9865 9.1709L39.1503 12.2165Z",
    fill: "#4FC2C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6915 29.5738L34.2012 31.9401L35.6915 29.5738ZM42.1716 25.7646L48.8037 27.0952L42.1716 25.7646Z",
    fill: "#FBD1CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0873 27.3557L35.6915 29.5733L34.2012 31.9396L37.8324 32.6666L40.6985 28.0715L37.0729 27.3445L37.0873 27.3557ZM42.1573 25.7529L40.6985 28.0715L47.3305 29.4021L48.7922 27.0835L42.1602 25.7529",
    fill: "#FBD1CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5476 25.0361L37.0859 27.3548L40.7115 28.0818L42.1703 25.7631L38.5476 25.0361Z",
    fill: "#F9BDB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7123 28.083L37.8262 32.6669L44.4553 33.9974L47.3414 29.4135L40.7123 28.083Z",
    fill: "#F9BDB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5476 25.0361L37.0859 27.3548L38.5476 25.0361Z",
    fill: "#F7ADA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4544 26.0244L27.5684 30.6083L30.4544 26.0244Z",
    fill: "#EEC581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2936 22.9795L26.8319 25.2981L30.4546 26.0251L28.2936 22.9795Z",
    fill: "#ECAF6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4544 26.0244L27.5684 30.6083L30.4544 26.0244Z",
    fill: "#EFC176"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8314 25.2979L23.9453 29.8817L27.568 30.6087L30.4542 26.0249L26.8314 25.2979Z",
    fill: "#EEC076"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8319 25.2979L30.4546 26.0249L26.8319 25.2979Z",
    fill: "#EDB76C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9453 29.8818L27.568 30.6089L23.9453 29.8818Z",
    fill: "#DABC75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6914 27.8232L15.8553 30.8716L22.4844 32.2022L23.9461 29.8808L13.6914 27.8232Z",
    fill: "#FFDA97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8924 18.1318L41.4336 20.4532L45.0563 21.1803L42.8924 18.1318Z",
    fill: "#EA877D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4349 20.4521L38.5488 25.036L42.1715 25.763L45.0576 21.1792L41.4349 20.4521Z",
    fill: "#EB8F85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2988 21.0908L50.414 24.1364L60.7174 26.194L58.5535 23.1484L48.2988 21.0908Z",
    fill: "#ABD69E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.876 51.1327L182.125 48.6625L174.195 47.0709L173.813 46.9951L170.291 52.5895L172.005 55.0597L180.314 56.727L180.319 56.7186L180.354 56.727L183.876 51.1327Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.008 55.0615L180.319 56.7289L172.088 55.0784L172.011 55.0615",
    fill: "#9CDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.084 55.075L180.315 56.7255L172.078 55.0806L172.084 55.075ZM180.931 50.5557L178.598 54.2637L180.318 56.703L183.82 51.1395L180.92 50.5585",
    fill: "#9CDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.813 46.9951L175.527 49.4653L173.191 53.1734L175.527 49.4653L180.935 50.5488L180.941 50.5432L175.567 49.4653L173.813 46.9951Z",
    fill: "#9CDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.527 49.4658L173.191 53.1739L178.602 54.2574L180.935 50.5493L175.527 49.4658Z",
    fill: "#71CECE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.814 46.9951L175.568 49.4653L183.877 51.1327L182.126 48.6625L174.196 47.0709L173.814 46.9951Z",
    fill: "#4FC2C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.604 54.2575L180.355 56.7276L183.877 51.1333L182.126 48.6631L178.604 54.2575Z",
    fill: "#42B2AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.291 52.5908L172.005 55.061L180.354 56.7284L178.603 54.2582L170.291 52.5908Z",
    fill: "#4FC2C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.813 46.9951L170.291 52.5895L173.191 53.1734L175.527 49.4653L173.813 46.9951Z",
    fill: "#63C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.291 52.5908L172.005 55.061L173.191 53.1747L170.291 52.5908Z",
    fill: "#4FC2C2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4184_24265"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 184,
    height: 64,
    fill: "white",
    transform: "translate(0 0.000976562)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeyondLogo);
export default __webpack_public_path__ + "static/media/BeyondLogo.d0d96a488377c5f22a4d25e3b7fa4ede.svg";
export { ForwardRef as ReactComponent };